import { render, staticRenderFns } from "./resa2.vue?vue&type=template&id=06051b74&"
import script from "./resa2.vue?vue&type=script&lang=js&"
export * from "./resa2.vue?vue&type=script&lang=js&"
import style0 from "./resa2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./resa2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports